import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import Icon from '~Scenes/SelfServiceKiosks/Components/Icon';
import { useIsLandscape } from '~Scenes/SelfServiceKiosks/Hooks/useIsLandscape';
import checkIcon from '../Assets/check.svg';
import deleteIcon from '../Assets/delete.svg';

const SIZE = 72;
const LANDSCAPE_SIZE = 54;
const STROKE_WIDTH = 4;
const PROGRESS_COLOR = '#209946';
const BACKGROUND_COLOR = '#eeeef1';
const FAILED_COLOR = '#e3273b';

const Circle = styled.div`
  position: relative;
  width: ${SIZE}px;
  height: ${SIZE}px;

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }
  svg:nth-child(2) {
    transform: rotate(90deg);
    circle {
      transition: all 1s ease-in-out;
    }
  }

  @media (orientation: landscape) {
    width: ${LANDSCAPE_SIZE}px;
    height: ${LANDSCAPE_SIZE}px;
  }
`;
const Response = styled.div<{ size: number; color: string; show: boolean }>`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: background-color 0.3s ease-in-out, opacity 0.35s 1s ease-in-out;
`;

interface Props {
  status?: 'PENDING' | 'FAILED' | 'COMPLETED';
}
const CircleProgress = ({ status }: Props) => {
  const [run, setRun] = useState(false);
  const [success, setSuccess] = useState(true);
  const isLandscape = useIsLandscape();
  const size = isLandscape ? LANDSCAPE_SIZE : SIZE;
  const RADIUS = size / 2 - STROKE_WIDTH / 2;
  const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

  useEffect(() => {
    if (!status || status === 'PENDING') return;

    setRun(true);
    setSuccess(status === 'COMPLETED');
  }, [status]);

  return (
    <Circle>
      <svg height={size} width={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={RADIUS}
          stroke={BACKGROUND_COLOR}
          strokeWidth={STROKE_WIDTH}
          fillOpacity="0"
        />
      </svg>
      <svg height={size} width={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={RADIUS}
          stroke={PROGRESS_COLOR}
          strokeWidth={STROKE_WIDTH}
          fillOpacity="0"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={CIRCUMFERENCE / Number(!run)}
        />
      </svg>
      {success ? (
        <Response size={size} color={PROGRESS_COLOR} show={run}>
          <Icon
            icon={checkIcon}
            height={isLandscape ? 25 : 34}
            width={isLandscape ? 29 : 39}
            color={'#fff'}
          />
        </Response>
      ) : (
        <Response size={size} color={FAILED_COLOR} show={run}>
          <Icon icon={deleteIcon} size={isLandscape ? 22 : 30} color={'#fff'} />
        </Response>
      )}
    </Circle>
  );
};

export default CircleProgress;
